<template>
  <div style="padding-top: 100px">
    <PageContainer>
      <h1 class="text-center mb-12">Whoops! Your session expired!</h1>
      <v-layout justify-center>
        <v-card class="pa-6" width="600px">
          <v-card-title class="mb-4">
            <h1 class="secondary--text text-center width-100">401</h1>
          </v-card-title>
          <v-card-actions>
            <v-btn block color="secondary" @click="onClicked">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </PageContainer>
  </div>
</template>

<script>
import api from "../../api";

export default {
  methods: {
    onClicked() {
      api.auth.endUserSession(this);
    },
  },
};
</script>
